var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBox = function SvgCheckBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "checkBox_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".checkBox_svg__st2{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24z",
    style: {
      fill: "#fff",
      fillOpacity: 0.01
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.5H4c-.8 0-1.5.7-1.5 1.5v13c0 .8.7 1.5 1.5 1.5h13c.8 0 1.5-.7 1.5-1.5V4c0-.8-.7-1.5-1.5-1.5z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.5V21c0 .6-.4 1-1 1H6.5M6.5 10.2l3 2.8 5-5.1",
    className: "checkBox_svg__st2"
  })));
};
export default SvgCheckBox;